import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=697cf46f&scoped=true&"
import script from "./weight.vue?vue&type=script&lang=js&"
export * from "./weight.vue?vue&type=script&lang=js&"
import style0 from "./weight.vue?vue&type=style&index=0&id=697cf46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697cf46f",
  null
  
)

export default component.exports